export const VEHICLE = "vehicleId";
export const USER = "userId";
export const START_USER = "startUserId";
export const END_USER = "endUserId";
export const HEADQUARTER = "headquarterId";
export const LOCATION = "locationId";
export const RANGE_START_DATE = "rangeStartDate";
export const RANGE_END_DATE = "rangeEndDate"; 